<template>
  <ppt-slide-viewer module-code="robot_map" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "RobotMap",
  components: { PptSlideViewer }
};
</script>
